import React from "react";
import {Box, Grid, Typography} from "@material-ui/core";
import {useSelector} from "react-redux";
import {RootState} from "../../../../reducers";
import {useActions} from "../../../../actions";
import * as AccountActions from "../../../../actions/account";
import {getCurrentPolicyYear, nextAnniversaryDate} from "../../../clientServicing/ClientServiceDashbaord";
import moment from "moment/moment";
import numeral from "numeral";
import {Loader} from "../../../../components/Common";
import {getAllocationFromStressRequest} from "../../../../utils/commonFunc";
import useGetAllocations from "../../../../hooks/useGetAllocations";
import {validObj} from "../../../../utils/commonUtils";


const ProposalSummary = ({clientPolicyId}:{clientPolicyId?:string | false} ) => {

    const { user } = useSelector((state: RootState) => state.auth);
    const accountActions = useActions(AccountActions);
    clientPolicyId  = clientPolicyId || user.client && user.client.clientPolicies && user.client.clientPolicies.length > 0 && user.client.clientPolicies[0].id;
    const [caseDetails, setCaseDetails] = React.useState<any>(null);

    const  carrierId = caseDetails && caseDetails.carrierId ;
    const  strategyId =  caseDetails && caseDetails.strategyId;
    const allocationQuestion = useGetAllocations(carrierId, strategyId)
    const [loading, setLoading] = React.useState<boolean>();
    const estimatedDetails = caseDetails && caseDetails.estimatedDetails && caseDetails.estimatedDetails.length > 0 && caseDetails.estimatedDetails[0];
    const issueDate = caseDetails && caseDetails.tranche && caseDetails.tranche.issueDate || moment().format("MM/DD/YYYY");
    let anniversaryDate = nextAnniversaryDate(issueDate);
    let currentPolicyYear:number = getCurrentPolicyYear(anniversaryDate)
    let currentPolicyYearDetails:any = caseDetails && caseDetails.policyBreakDowns && caseDetails.policyBreakDowns.find((val) => val.policyYear === currentPolicyYear) || caseDetails && Array.isArray(caseDetails.policyBreakDowns) && caseDetails.policyBreakDowns[0];

    // let currentPolicyYear:number = getCurrentPolicyYear(anniversaryDate)
    // let currentPolicyYearDetails:any = caseDetails && caseDetails.policyBreakDowns && caseDetails.policyBreakDowns.find((val) => val.policyYear === currentPolicyYear);
    let initialDeathBenefit = numeral(caseDetails && caseDetails.benefitAmounts && caseDetails.benefitAmounts.initialTotalDeathBenefit).value();

    const getClientCaseDetails = async (clientPolicyId: string) => {
        setLoading(true)
        const details = await accountActions.getProposalSummary(clientPolicyId);
        setCaseDetails(details);
        setLoading(false)
    };

    const allocationFromStressRequest = allocationQuestion && validObj(allocationQuestion) && estimatedDetails && estimatedDetails.stressRequest ? getAllocationFromStressRequest(allocationQuestion, estimatedDetails) : [];

   React.useEffect(()=>{
       if(clientPolicyId){
           getClientCaseDetails(clientPolicyId).then(() => {
           });
       }
   },[clientPolicyId])
    const getCaseDetail =(key) => caseDetails && caseDetails[key]
    if (loading) {
        return (
                <Box p={4} mx="auto">
                    <Loader />
                </Box>
        );
    }


    return (
            <Box p={4} mx="auto">
                <Typography variant="h6" className={"mb30"}>
                    Proposal Summary
                </Typography>

                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <Typography>Client Name:</Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography align="right">{caseDetails && caseDetails.client && caseDetails.client.user && caseDetails.client.user.name}</Typography>
                    </Grid>

                    <Grid item xs={6}>
                        <Typography>Agent Name:</Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography align="right">{caseDetails && caseDetails.agent && caseDetails.agent.user && caseDetails.agent.user.name}</Typography>
                    </Grid>

                    <Grid item xs={6}>
                        <Typography>Initial Death Benefit:</Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography align="right">{ numeral(initialDeathBenefit || 0).format('$0,0')}</Typography>
                    </Grid>

                    <Grid item xs={6}>
                        <Typography>Client Contribution (includes trust fee):</Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography align="right">{numeral(getCaseDetail("issuedContribution") || 0).format('$0,0')}</Typography>
                    </Grid>

                    <Grid item xs={6}>
                        <Typography>Total Premium:</Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography align="right">{ numeral((currentPolicyYearDetails && currentPolicyYearDetails.illustratedPremium) || getCaseDetail("annualPremium") || 0).format('$0,0')}</Typography>
                    </Grid>

                    <Grid item xs={6}>
                        <Typography>Index Options:</Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography align="right">
                            {
                                allocationFromStressRequest.map((i: { label: any; weight: any; }, idx: any) => (
                                        <React.Fragment key={idx}>
                                            {i.label}, {i.weight}% <br />
                                        </React.Fragment>
                                ))
                            }
                        </Typography>
                    </Grid>
                </Grid>
            </Box>
    );
};

export default ProposalSummary;
